import { render, staticRenderFns } from "./DigitalAgreementDetail.vue?vue&type=template&id=7b12927d&scoped=true"
import script from "./DigitalAgreementDetail.vue?vue&type=script&lang=js"
export * from "./DigitalAgreementDetail.vue?vue&type=script&lang=js"
import style0 from "./DigitalAgreementDetail.vue?vue&type=style&index=0&id=7b12927d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b12927d",
  null
  
)

export default component.exports